import { UseInfiniteQueryOptions, UseInfiniteQueryResult, useInfiniteQuery } from 'react-query'
import {
  COMPANY_LABELS_QUERY_KEY,
  OWN_LABELS_QUERY_KEY,
} from 'api/queriesKeys'
import { useFetch } from 'providers/FetchProvider'
import { GetLabelsQueryOption, LabelsContentResponse } from 'api/queries/labels/types'

const LABELS_PAGE_SIZE = 25

const useGetLabelsQuery = (
  queryOptions?: GetLabelsQueryOption,
  useQueryOptions?: Omit<UseInfiniteQueryOptions<LabelsContentResponse, Error>, 'queryKey'>
): UseInfiniteQueryResult<LabelsContentResponse, Error> => {
  const { fetch } = useFetch()

  let queryKey = OWN_LABELS_QUERY_KEY
  let url = '/label'
  if (queryOptions?.companyId !== undefined) {
    queryKey = COMPANY_LABELS_QUERY_KEY
    url = `/label/company/${queryOptions.companyId}`
  }

  return useInfiniteQuery(
    [queryKey, { queryOptions }],
    async ({ pageParam = 0 }) => {
      const { data } = await fetch.get(url, {
        params: {
          ...queryOptions,
          page: pageParam,
          size: LABELS_PAGE_SIZE,
        },
      })
      return data
    },
    useQueryOptions
  )
}

export { useGetLabelsQuery }
